import {RouteConfig} from 'vue-router';
import ChallengeTeamForm from '@/components/Challenges/tabs/teams/ChallengeTeamForm.vue';
import ChallengeTeams from '@/components/Challenges/tabs/teams/all/ChallengeTeams.vue';
import ChallengeTeam from '@/components/Challenges/tabs/teams/ChallengeTeam.vue';
import {teamRoutes} from '@/routes/team.router';
import TeamMembers from '@/components/Challenges/tabs/teams/members/TeamMembers.vue';
import {authenticated} from '@/guards/auth.guard';

export const challengeTeamsRouter: RouteConfig[] = [
    {
      path: '',
      name: 'challenge-teams',
      component: ChallengeTeams,
    },
    {
      path: 'new',
      name: 'challenge-new-team',
      component: ChallengeTeamForm,
      beforeEnter: (to, from, next) => {
        if (authenticated()) {
          next()
        } else {
          next(from.path)
        }
      }
    },
    {
      path: 'my',
      name: 'challenge-my-team',
      component: ChallengeTeam,
      children: teamRoutes,
      beforeEnter: (to, from, next) => {
        if (authenticated()) {
          next()
        } else {
          next(from.path)
        }
      }
    },

    {
      path: ':teamSlug',
      name: 'show-team',
      component: ChallengeTeam,
      children: [
        {
          path: 'members',
          name: 'show-team-members',
          component: TeamMembers,
        }
      ]
    },
  ]
;
